(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["cio-form"]) return;
  try {
    
  
  $(document).ready(function(){
    $('.cfs-form').submit(function(e){
      e.preventDefault();
      let form = $(this);
      let email = form.find("input[name='email']");
      console.log(form, email);
      if(email.length && !!email.val()){
        console.log(email.length, email.val());
        form.hide();
        form.parent().find('.cfs-form-success').show();
      }
    });
    $('.cfs-checkbox.required').each(function(){
      $(this).closest('.cio-form-section').find('.Form__Submit').prop('disabled', true);
    });

    $('.cfs-checkbox').on('click',function(){
      if( $(this).hasClass('required') ){
        if($(this).hasClass('active')){
          $(this).removeClass('active');
          $(this).closest('.cio-form-section').find('.Form__Submit').prop('disabled', true);
        }else{
          $(this).addClass('active');
          $(this).closest('.cio-form-section').find('.Form__Submit').prop('disabled', false);
        }
      }else{
        $(this).toggleClass('active');
      }
      
      
    })
  });

  } catch(e) { console.error(e); }
})();

})();
